import { useEffect } from 'react';
import { BaseLayout } from '@layouts/BaseLayout';
import { Navbar } from '@components/assessors/organisms/Navbar/Navbar';
import { Footer } from '@components/shared/organisms/Footer/Footer';
import { Alert } from '@acb_devel/design-system';
import { useEventsContext } from '@contexts/EventsContext';
import { getEvents } from '@services/events';

import styles from './AssessorLayout.module.scss';

export function AssessorLayout({ children }: { children: React.ReactNode }) {
  const { setEvents } = useEventsContext();

  useEffect(() => {
    getEvents({
      ended: false,
      ordering: 'start_event',
    }).then(({ results }) => {
      setEvents(results);
    });
  }, [setEvents]);

  return (
    <BaseLayout>
      <div className={`${styles.assessorLayout}`}>
        <Navbar />
        <main className={styles.main}>{children}</main>
        <Footer />
      </div>
      <div className={styles.alert}>
        <Alert
          variant="info"
          direction="column"
          title="Aviso"
          text="Panel de control solo accesible desde ordenadores de escritorio."
        />
      </div>
    </BaseLayout>
  );
}
